import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '@/shared/state/store';
import { type Mode, MODES } from '@/shared/mode/types';
import { deriveMode } from '@/shared/mode/deriveMode';

export function useTabHistory() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentMode = deriveMode(pathname);
  const lastTabUrl = useStore(s => s.lastTabUrl);
  const pushTab = useStore(s => s.pushTab);
  const popTab = useStore(s => s.popTab);

  function tapMode(mode: Mode) {
    if (mode === currentMode) {
      // Tap-to-top: navigate to mode home
      navigate(`/${mode}`);
    } else {
      // Resume mode at its last URL
      navigate(lastTabUrl(mode));
    }
  }

  function recordNav(url: string) {
    const m = deriveMode(url);
    pushTab(m, url);
  }

  function back() {
    const url = popTab(currentMode);
    if (url) navigate(url);
    else if (window.history.length > 1) navigate(-1);
  }

  return { currentMode, tapMode, recordNav, back, MODES };
}
